type ChangeRequestsPanelVisibilityInput = {
  sectionId: string | null | undefined;
  canManageChangeRequests: boolean;
  permissionProbeLoading: boolean;
  canViewTasks: boolean;
};

type ChangeRequestsSectionVisibilityInput = ChangeRequestsPanelVisibilityInput & {
  totalPendingCount: number;
};

export function shouldShowChangeRequestsPanel({
  sectionId,
  canManageChangeRequests,
  permissionProbeLoading,
  canViewTasks
}: ChangeRequestsPanelVisibilityInput): boolean {
  return !!sectionId && (canManageChangeRequests || (permissionProbeLoading && !canViewTasks));
}

export function shouldShowChangeRequestsSection({
  sectionId,
  canManageChangeRequests,
  permissionProbeLoading,
  canViewTasks,
  totalPendingCount
}: ChangeRequestsSectionVisibilityInput): boolean {
  if (
    !shouldShowChangeRequestsPanel({
      sectionId,
      canManageChangeRequests,
      permissionProbeLoading,
      canViewTasks
    })
  ) {
    return false;
  }

  // Keep visible only during the first-load permission probe — not later
  // cache-and-network loading pulses after empty data is already resolved.
  if (permissionProbeLoading) {
    return true;
  }

  return totalPendingCount > 0;
}
